export default __webpack_public_path__ + "static/media/ic_gmx_arbitrum.3eb71802.svg";